module.exports = __webpack_public_path__ + "img/amen.a7600ce4.jpeg";